import * as actions from '../actionTypes'

// pageDocs is { first: <doc>, last: <doc> } for that page, and used by prev/next
const initialState = { 
    value: []
}

export default function projectGridPageDocs(state = initialState, action) {

    switch(action.type) {

        case actions.SET_PROJECT_GRID_PAGE_DOCS: {

            //console.log('[redux] Setting project grid page docs value', action.payload.value)
            return {
                ...state,
                value: action.payload.value
            }
        }

        default:
            return state
    }
}